module.exports = __webpack_public_path__ + "static/media/hands_02.076756f2.svg";